import React, { useEffect, useState } from "react";
import { Table, Pagination } from "react-bootstrap";
import {
  FiPlus,
  FiHome,
  FiChevronRight,
  FiEdit,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSubject } from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Subjectlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [subjectdata, setsubjectdata] = useState([]);
  const [loading, setLoading] = useState(true);

  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const fetchclassSubject = () => {
    setLoading(true);


    dispatch(getSubject())
      .unwrap()
      .then((res) => {
        const subjectlist = res?.data || [];

        setsubjectdata(subjectlist);
        setTotalData(subjectlist.length);
      })
      .catch((err) => {
        toast.error("Failed to fetch subjects");

        setsubjectdata([]);
        setTotalData(0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchclassSubject();
  }, []);

  const totalPages = Math.ceil(totalData / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = subjectdata.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>

      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px"
                  }}
                />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">
              Subjects
            </span>

          </div>

          <Link
            to="/institute/add-subject"
            className="add-btn"
          >
            <FiPlus />
            Add Subject
          </Link>

        </div>
      </div>


      {/* ================= CARD ================= */}

      <div className="staff-card">

        <div className="table-responsive">

          <Table className="staff-table align-middle">

            <thead>
              <tr>
                <th className="text-center">#</th>

                <th className="text-center">
                  Subject Name
                </th>

                <th className="text-center">
                  Action
                </th>
              </tr>
            </thead>


            <tbody>

              {/* ================= SKELETON ================= */}

              {loading ? (

                Array.from({ length: 8 }).map((_, index) => (

                  <tr key={index}>

                    <td className="text-center">
                      <Skeleton width={30} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={180} />
                    </td>

                    <td className="text-center">
                      <Skeleton
                        width={35}
                        height={30}
                        borderRadius={5}
                      />
                    </td>

                  </tr>

                ))

              ) : paginatedData.length === 0 ? (

                <tr>
                  <td
                    colSpan="3"
                    className="text-center"
                  >
                    No subjects found
                  </td>
                </tr>

              ) : (

                paginatedData.map((item, index) => (

                  <tr key={item._id}>

                    <td className="text-center">
                      {startIndex + index + 1}
                    </td>

                    <td className="text-center">
                      {item?.name}
                    </td>

                    <td className="text-center">

                      <button
                        className="edit-btn"
                        onClick={() =>
                          navigate(
                            `/institute/edit-subject/${item._id}`
                          )
                        }
                      >
                        <FiEdit size={16} />
                      </button>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </Table>

        </div>


        {/* ================= PAGINATION ================= */}

        {!loading && totalData > itemsPerPage && (

          <div className="d-flex justify-content-end my-3">

            <Pagination className="mb-0">

              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage((p) => p - 1)
                }
              />

              {Array.from(
                { length: totalPages },
                (_, index) => {

                  const page = index + 1;

                  if (
                    page === 1 ||
                    page === totalPages ||
                    (
                      page >= currentPage - 1 &&
                      page <= currentPage + 1
                    )
                  ) {
                    return (
                      <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() =>
                          setCurrentPage(page)
                        }
                      >
                        {page}
                      </Pagination.Item>
                    );
                  }

                  if (page === currentPage - 2) {
                    return (
                      <Pagination.Ellipsis
                        key={`left-${page}`}
                        disabled
                      />
                    );
                  }

                  if (page === currentPage + 2) {
                    return (
                      <Pagination.Ellipsis
                        key={`right-${page}`}
                        disabled
                      />
                    );
                  }

                  return null;
                }
              )}

              <Pagination.Next
                disabled={
                  currentPage === totalPages ||
                  totalPages === 0
                }
                onClick={() =>
                  setCurrentPage((p) => p + 1)
                }
              />

            </Pagination>

          </div>

        )}

      </div>
    </>


  );
}
